/**
 * Default flow execution/settings object (legacy AgenticFlowBuilder parity).
 * Stored on the V2 definition as `definition.settings` and forwarded to Python as `flow.settings`.
 */
export const STUDIO_V2_DEFAULT_FLOW_SETTINGS = {
  enableParallelExecution: true,
  autoSaveState: true,
  enableExecutionLogging: false,
  enableVariableSubstitution: true,
  enableDebugMode: false,
  maxExecutionTime: 300,
  executionTimeout: 30000,
  langgraphContinuationTimeout: 20,
  backgroundTaskTimeout: 30,
  onError: 'stop',
  maxRetryAttempts: 3,
  retryDelay: 5,
  logAllErrors: true,
  persistStateBetweenRuns: true,
  enableStateValidation: false,
  autoSaveStateVariables: true,
  enableStateEncryption: false,
  stateCleanupInterval: 24,
  maxStateSize: 10,
  enableSandboxedExecution: true,
  requireAuthentication: false,
  apiRateLimit: 60,
  enableAuditLogging: false,
  validateInputData: true,
  sessionTimeout: 30,
  enableCaching: true,
  enableCompression: false,
  enablePerformanceMonitoring: false,
  optimizeMemoryUsage: true,
  cacheTTL: 3600,
  maxConcurrentNodes: 5,
  enableApiCalls: true,
  enableWebhookNotifications: false,
  enableExternalDatabaseConnections: false,
  enableEmailNotifications: true,
  defaultApiTimeout: 30,
  webhookRetryAttempts: 3,
  errorWorkflowId: null,
};

export function mergeV2DefinitionSettings(raw) {
  return {
    ...STUDIO_V2_DEFAULT_FLOW_SETTINGS,
    ...(raw != null && typeof raw === 'object' ? raw : {}),
  };
}
